import { render, staticRenderFns } from "./ConfirmSelect.vue?vue&type=template&id=70922796"
import script from "./ConfirmSelect.vue?vue&type=script&lang=js"
export * from "./ConfirmSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports